import React, { useState } from 'react';
import { CompanyEdition } from '../modules/auth/components/CompanyEdition';
import { FirstCompanyProps } from '../models/FirstCompanyModel';
import { FirstUserProps } from '../models/FirstUserModel';

export const multiStepContext = React.createContext<any>(null);

const CompanyEditContext = () => {
  const [currentStep, setStep] = useState(1);
  const [userData, setUserData] = useState([]);
  const [finalData, setFinalData] = useState<any[]>([]);
  const [data, setData] = useState([]);
  const [loadedData, setLoadedData] = useState(false);
  const [loading, setLoading] = useState(false);
  const [companyStatus, setCompanyStatus] = useState<string>('');

  const [firstUser, setFirstUser] = useState<FirstUserProps>({
    user: {
      email: '',
      confirma_email: '',
      password: '',
      confirma_password: '',
      role: 1,
      active: true,
    },
    complemento: {
      tipo_doc: '',
      numero_doc: '',
      primer_nome: '',
      segundo_nome: '',
      primer_apelido: '',
      segundo_apelido: '',
      fecha_nascimiento: '',
      ciudad: '',
      estrato: '',
      localidad: '',
      upz: '',
      bairro: '',
      celular: '',
      correo: '',
      cargo: '',
      pregunta_seguridad: '',
      respuesta: '',
    },
  });
  const [firstCompany, setFirstCompany] = useState<FirstCompanyProps>({
    company: {
      codigo_ciiu: undefined,
      razon_social: '',
      tipo_documento: '',
      numero_documento: '',
      naturaleza: '',
      tipo: '',
      Tamano_empleados: '',
      pertence: '',
      local: '',
      localidad: '',
      latitud: 0,
      longitud: 0,
      id_coordenada: '',
      id_coordenada_02: '',
      id_coordenada_03: '',
      id_coordenada_04: '',
      id_coordenada_05: '',
      id_coordenada_06: '',
      id_coordenada_07: '',
      id_coordenada_08: '',
      id_coordenada_09: '',
      tipo_complemento: '',
      codigo_postal: '',
      direccion_residencia: '',
      pais: '',
      departamento: '',
      municipio: '',
      prestador_principal: '',
      punta_atencion: '',
      descricion_employer: '',
      intereses_empresa: '',
      programas_corporativos: '',

      contacto_correo_electronico: '',
      contacto_direccion: '',
      contacto_direccion_coordenadas: '',

      repre_nombre1: '',
      repre_nombre2: '',
      repre_apellido1: '',
      repre_apellido2: '',
      repre_tipo_documento: '',
      repre_numero_documento: '',
      repre_cargo: '',
      repre_telefono: '',
      repre_correo_electronico: '',

      // NUEVOS CAMPOS DE GREMIOS
      gremio_principal_id: null,
      gremio_secundario_id: null,
    },
    complemento: [
      {
        tipo_complemento: '',
        complemento: '',
      },
    ],
  });

  const submitData = () => {
    setFinalData((finalData) => [...finalData, userData]);
    setUserData([]);
  };

  return (
    <div>
      <multiStepContext.Provider
        value={{
          currentStep,
          setStep,
          firstUser,
          setFirstUser,
          firstCompany,
          setFirstCompany,
          userData,
          setUserData,
          finalData,
          setFinalData,
          submitData,
          data,
          setData,
          loadedData,
          setLoadedData,
          loading,
          setLoading,
          companyStatus,
          setCompanyStatus,
        }}
      >
        <CompanyEdition />
      </multiStepContext.Provider>
    </div>
  );
};

export default CompanyEditContext;